import { AuthLevel, generateApiPath } from '@guiker/shared-framework'

const paths = {
  rentPaymentsPlan: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'rent-payments-plan' }),
}

export { paths }
